import * as React from "react";
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  styled,
  Tooltip,
} from "@mui/material";

import { SearchListItemLink } from "./SearchListItemLink";
import { priceFormat, formatDateTime } from "src/common/UtilFunctions";
import { OrderStatusEnumIcons } from "src/common/enum";

export const OrderListItem = (props: any) => {
  const { data, onClick } = props;
  const { content } = data;

  if (!content) {
    return null;
  }

  return (
    <ListItem
      component={SearchListItemLink}
      data={data}
      onClick={onClick}
      alignItems="flex-start"
      sx={{
        textDecoration: "none",
        "&:hover": {
          textDecoration: "none",
        },
        "& a": {
          textDecoration: "none",
        },
        "& a:hover": {
          textDecoration: "none",
        },
      }}
      data-testid="customer"
    >
      <ListItemAvatar
        sx={{
          marginX: 1,
        }}
      >
        <Tooltip placement="top" title={OrderStatusEnumIcons.find((status) => status.id === content.status).name}>
          <Avatar>
            {OrderStatusEnumIcons.find((status) => status.id === content.status).icon}
          </Avatar>
        </Tooltip>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography
            color="textPrimary"
            sx={{
              textTransform: "capitalize",
            }}
          >
            {content.increment_id}
          </Typography>
        }
        secondary={
          <Box display="flex" flexDirection="row" gap={5}>
            <Typography color="textSecondary">
              {formatDateTime(content.created_at)}
            </Typography>
            <Typography
              color="textSecondary"
              sx={{
                textTransform: "capitalize",
                marginLeft: "auto",
              }}
            >
              {priceFormat(content.total, content.currency)}
            </Typography>
          </Box>
        }
        secondaryTypographyProps={{ component: "div" }}
      />
    </ListItem>
  );
};

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 25,
  height: 25,
  border: `1px solid ${theme.palette.background.paper}`,
}));
